import {
  idColumn,
  actionColumn,
  statusColumn,
  codeColumn,
} from "../../../../../utils/commonColumns";
import { generateColumn, renderNA } from "../../../../../utils/commonFunctions";

const useColumnDefs = [
    idColumn,
    codeColumn,
    {
      ...generateColumn("", "career_level"),
    },
    {
      ...generateColumn("", `careers`),
      cellRenderer: (props: any) => {
        return renderNA(
          props.data?.[`careers`]
            ?.map((data: any) => {
              return data?.name;
            })
            ?.toString()
        );
      },
      filterValueGetter: (props: any) => {
        return renderNA(
          props.data?.[`careers`]
            ?.map((data: any) => {
              return data?.name;
            })
            ?.toString()
        );
      },
      tooltipValueGetter: (props: any) => {
        return renderNA(
          props.data?.[`careers`]
            ?.map((data: any) => {
              return data?.name;
            })
            ?.toString()
        );
      },
      valueGetter: (props: any) => {
        return props.data?.[`careers`]
          ?.map((data: any) => {
            return data?.name;
          })
          ?.join("#");
      },
    },
    {
      ...generateColumn("Industry Name", "industry_name"),
      cellRenderer: (props: any) => {
        return renderNA(props?.data?.industry_name);
      },
      filterValueGetter: (props: any) => {
        return renderNA(props?.data?.industry_name);
      },
      tooltipValueGetter: (props: any) => {
        return renderNA(props?.data?.industry_name);
      },
      valueGetter: (props: any) => {
        return props?.data?.industry_name;
      },
    },
    {
      ...generateColumn("Education Training", "education_training.name"),
      cellRenderer: (props: any) => {
        return renderNA(props?.data?.education_training?.name);
      },
      filterValueGetter: (props: any) => {
        return renderNA(props?.data?.education_training?.name);
      },
      tooltipValueGetter: (props: any) => {
        return renderNA(props?.data?.education_training?.name);
      },
      valueGetter: (props: any) => {
        return props?.data?.education_training?.name;
      },
    },
    {
      ...generateColumn("Education Level", "education_level.name"),
      cellRenderer: (props: any) => {
        return renderNA(props?.data?.education_level?.name);
      },
      filterValueGetter: (props: any) => {
        return renderNA(props?.data?.education_level?.name);
      },
      tooltipValueGetter: (props: any) => {
        return renderNA(props?.data?.education_level?.name);
      },
      valueGetter: (props: any) => {
        return props?.data?.education_level?.name;
      },
    },
    {
      ...generateColumn("Experience", "experience.experience"),
      cellRenderer: (props: any) => {
        return renderNA(props?.data?.experience?.experience);
      },
      filterValueGetter: (props: any) => {
        return renderNA(props?.data?.experience?.experience);
      },
      tooltipValueGetter: (props: any) => {
        return renderNA(props?.data?.experience?.experience);
      },
      valueGetter: (props: any) => {
        return props?.data?.experience?.experience;
      },
    },
    {
      ...generateColumn("Experience Level", "experience_level?.name"),
      cellRenderer: (props: any) => {
        return renderNA(props?.data?.experience_level?.name);
      },
      filterValueGetter: (props: any) => {
        return renderNA(props?.data?.experience_level?.name);
      },
      tooltipValueGetter: (props: any) => {
        return renderNA(props?.data?.experience_level?.name);
      },
      valueGetter: (props: any) => {
        return props?.data?.experience_level?.name;
      },
    },
    statusColumn,
    actionColumn,
  ];
export default useColumnDefs;
